import React, {useEffect, useState} from "react";
import {Button, Card} from "react-bootstrap";
import adminUsersApi from "../../../api/adminUsers";
import {NavLink} from "react-router-dom";
import Loader from "../../../components/Loader";
import {Edit2} from "react-feather";
import notyf from "../../../utils/notyfApi";
import ReactDataGridCustom from "../../../components/customComponents/ReactDataGridCustom";
import {useExcelDownloder} from "react-xls";
import moment from "moment";
import TableViewIcon from "@mui/icons-material/TableView";

const defaultFilterValue = [
    {name: 'year', operator: 'contains', type: 'string', value: ''},
    {name: 'weekly', operator: 'contains', type: 'string', value: ''},
    {name: 'full_name', operator: 'contains', type: 'string', value: ''},
];

const columns = [
    {
        name: "year",
        header: "Jaar",
        flex: 1,
    },
    {
        name: "weekly",
        header: "Week",
        flex: 1,
    },
    {
        name: "full_name",
        header: "Door",
        flex: 1,
    },
    {
        name: "sum_hours",
        header: "Aantal uren",
        flex: 1,

        render: ({value}) => {
            if(value) return parseFloat(value)
        },
    },
    {
        name: "completed",
        header: "Actief",
        render: ({value}) => {
            if (value === true) {
                return <span className="badge bg-success">INGEDIEND</span>;
            } else {
                return <span className="badge bg-danger">OPENSTAAND</span>;
            }
        },
        flex: 1,
    },
    {
        name: "Acties",
        header: "",
        render: ({data}) => {
            return <NavLink to={`/timesheets/${data.year}/${data.weekly}/${data.user_id}`}> <Edit2/> </NavLink>
        },
        flex: 1,
    },
];

export default function AdminWeekTableHandler() {
    //get data from api
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    const {ExcelDownloder} = useExcelDownloder(); // Hook voor excel download van tabel


    useEffect(() => {
        getData();
    }, []);


    const getData = async () => {
        const response = await adminUsersApi.getWeekstaten();
        if (!response.ok) return notyf.error("Error " + response.status)
        response.data.forEach((item, i) => {
            item.id = i + 1;
        })
        setDataSource({adminWeek: response.data})
        setLoading(false)

    };

    if (loading) return <Loader/>

    return (
        <Card>
            <Card.Header>
                <div className={"w-100 d-flex justify-content-between"}>
                    <h3 className={"mb-0"}>Weekstaten</h3>

                                                     <ExcelDownloder
                                                         data={dataSource}
                                                         filename={'Users ' + moment().format("DD-MM-YYYY")}
                                                         type={"link"}
                                                     >
                                <Button className={"me-1 added-tiny-margin-top remove-margin-top-mob"} variant={"secondary"}>
                                    <TableViewIcon fontSize={"small"}/>
                                </Button>
                            </ExcelDownloder>
                </div>
            </Card.Header>
            <Card.Body>
                <ReactDataGridCustom
                    idProperty="id"
                    dataSource={dataSource.adminWeek}
                    columns={columns}
                    pagination
                    defaultLimit={50}
                    defaultFilterValue={defaultFilterValue}
                />
            </Card.Body>
        </Card>
    );
}
